import { PaginationInquiry } from "../../../../helper/pagination";
import { MOption } from "../../shared/shared.model";

export interface Brand {
  uuid: string;
  imagePath: string;
  brand1Cuuid: string;
}

export enum ActionType {
  edit,
  delete,
}
export interface BrandUI extends Brand, MOption {
  key?: number;
  index?: number;
  actions?: Action[];
  file?: any;
  brandDto?: {
    brand1Cuuid: string;
    brand1Cname: string;
  };
}

export interface Action {
  icon: string;
  text: string;
  type: ActionType;
}
